import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product'
)({
  component: StpLayout,
})

function StpLayout() {
  return <FeatureGate feature='image' />
}
